// Override Settings
const boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		loadProductFirst: false,
		numberFilterTree: 2
	}
};

(function () {
	let onSale = false,
		soldOut = false,
		hasOnlyDefaultVariant = true,
		outOfStock = false,
		firstVariant = null,
		currentVariant = null,
		priceVaries = false,
		inventoryPolicy = 'deny',
		images = [];

	const isTouchDevice = window.matchMedia("(-moz-touch-enabled: 1), (hover: none)").matches;

	const descriptionTruncateLength = 70000;

	const sizeOptionLabels = boostPFSThemeConfig.optionLabels.size;
	const colorOptionLabels = boostPFSThemeConfig.optionLabels.color;

	const metafieldKeys = {
		variant: {
			showhide_product_badge: 'showhide_product_badge',
			product_badge_label: 'product_badge_label',
			product_badge_color: 'product_badge_color',
			product_badge_background: 'product_badge_background'
		}
	};

	const metafieldValues = {
		variant: {
			badge: {
				sale: 'sale'
			}
		}
	};

	BoostPFS.inject(this);

	Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		hasOnlyDefaultVariant = data.variants.length === 1;

		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		priceVaries = data.price_min !== data.price_max; // Check a product has many prices

		// Convert images to array
		images = data.images_info;

		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];

		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			let paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});

			if (typeof paramVariant[0] !== 'undefined') {
				firstVariant = paramVariant[0];
			}
		} else {
			for (let i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].id == data.variant_id) {
					firstVariant = data['variants'][i];
					break;
				}
			}

            // if oos, see if we can pick the next one
            if ( (firstVariant.fulfillment_service !== "gift_card") && (firstVariant.inventory_quantity < 1) ) {
              for (let i = 0; i < data['variants'].length; i++) {
                    tempVariant = data['variants'][i];
    				if ( tempVariant.inventory_quantity >= 1 ) {
    					firstVariant = tempVariant;
    					break;
    				}
    			}
            }  
		}

        currentVariant = firstVariant;


		onSale = currentVariant.compare_at_price > currentVariant.price; // Check if current variant is on sale

		outOfStock = (currentVariant.fulfillment_service !== "gift_card") && (currentVariant.inventory_quantity < 1) && (currentVariant.id !== 46152322711833);
		inventoryPolicy = currentVariant.inventory_policy;

		// console.log(data);
		// console.log(currentVariant);

		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) {
			data = this.data;
		}

		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		let template = this.buildTemplate(data);

		return template;
	};

	ProductGridItem.prototype.buildTemplate = function (product) {
		let template = boostPFSTemplate.productGridItemHtml.replace(/{{productId}}/g, product.id);

		let wishlistHtml 	= buildWishlistButton(product);
		let imagesHtml 		= buildProductCardImages(product);
		let bagdesHtml 		= buildProductCardBadges(product);
		let metaHtml 		= buildProductCardMeta(product);
        let metapartoneHtml = buildProductCardMetaPartOne(product);
        let metaparttwoHtml = buildProductCardMetaPartTwo(product);
		let dataHtml 		= buildProductCardData(product);

		template = template.replace(/{{wishlistButton}}/g, wishlistHtml);
		template = template.replace(/{{productImages}}/g, imagesHtml);
		template = template.replace(/{{productBadges}}/g, bagdesHtml);
		template = template.replace(/{{productMeta}}/g, metaHtml);
      	template = template.replace(/{{productMetaPartOne}}/g, metapartoneHtml);
		template = template.replace(/{{productMetaPartTwo}}/g, metaparttwoHtml);
		template = template.replace(/{{productData}}/g, dataHtml);

		// Add main attribute (Always put at the end of this function)
		template = template.replace(/{{itemId}}/g, product.id);
		template = template.replace(/{{itemTitle}}/g, product.title);
		template = template.replace(/{{itemHandle}}/g, product.handle);
		template = template.replace(/{{itemVendorLabel}}/g, product.vendor);
		template = template.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(product));

		return template;
	};
	/************************** END BUILD PRODUCT LIST **************************/

	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function getProductUrl(product) {
		return Utils.buildProductItemUrl(product);
	}

	function getProductUrlWithVariant(product, variant) {
		return `${Utils.buildProductItemUrl(product)}?variant=${variant.id}`;
	}

	function getProductBadgesDataValues(product, variant = currentVariant) {
		const data = {
			badgeShowValues: [],
			badgeLabelValues: [],
			badgeColorValues: [],
			badgeBackgroundColorValues: []
		};

		if (!product) {
			return data;
		}

		const variantMetafields = product.metafields.filter(
			(metafield) => parseInt(metafield.id) === parseInt(variant.id)
		);

		const badgeShow = variantMetafields.find(
			(metafield) => metafield.key === metafieldKeys.variant.showhide_product_badge
		);

		const badgeLabel = variantMetafields.find(
			(metafield) => metafield.key === metafieldKeys.variant.product_badge_label
		);

		const badgeColor = variantMetafields.find(
			(metafield) => metafield.key === metafieldKeys.variant.product_badge_color
		);

		const badgeBackgroundColor = variantMetafields.find(
			(metafield) => metafield.key === metafieldKeys.variant.product_badge_background
		);

		data.badgeShowValues = badgeShow?.value ? JSON.parse(badgeShow.value) : [];
		data.badgeLabelValues = badgeLabel?.value ? JSON.parse(badgeLabel.value) : [];
		data.badgeColorValues = badgeColor?.value ? JSON.parse(badgeColor.value) : [];
		data.badgeBackgroundColorValues = badgeBackgroundColor?.value ? JSON.parse(badgeBackgroundColor.value) : [];

		return data;
	}

	function buildWishlistButton(product) {
		if (!product) {
			return '';
		}

		let template = boostPFSTemplate.wishlistButtonHtml;

		template = template.replace(/{{productId}}/g, product.id);
		template = template.replace(/{{variantId}}/g, currentVariant.id);

		return template;
	}

	function buildProductCardImages(product) {
		if (!product) {
			return '';
		}

		const productUrl = getProductUrl(product);

		const secondaryImage = () => {
			if (isTouchDevice) {
				return '';
			}

			let image = images[0];

			if (!image) {
				return '';
			}

			let src = image.src;
			let alt = image.alt ?? product.title;

			return `<picture>
				<img
					srcset="${src.replace('.jpg', '_300x.jpg')} 1x, ${src.replace('.jpg', '_600x.jpg')} 2x"
					src="${src.replace('.jpg', '_300x.jpg')}"
					alt="${alt}"
					class="product-card__image product-card__image--secondary js-secondary-image"
					loading="lazy"
				/>
			</picture>`;
		};

		const featuredImage = () => {
			let image = currentVariant.image;

			if (!image) {
				image = Utils.getFeaturedImage(images).replace('_large.jpg', '.jpg');
			}

			if (!image) {
				image = boostPFSAppConfig.general.no_image_url;
			}

			let src = image;
			let alt = product.title;

			return `<picture>
				<img
					srcset="${src.replace('.jpg', '_300x.jpg')} 1x, ${src.replace('.jpg', '_600x.jpg')} 2x"
					src="${src.replace('.jpg', '_300x.jpg')}"
					alt="${alt}"
					class="product-card__image js-featured-image"
					loading="lazy"
				/>
			</picture>`;
		};

		const productImages = `<a href="${productUrl}" class="product-card__image-wrapper js-product-url">
			${secondaryImage()}
			${featuredImage()}
		</a>`;

		return `${productImages}`;
	}

	function buildProductCardBadges(product) {
		let emptyBadgesHtml = `<div class="product-card__badges" data-product-badges></div>`;

		if (!product) {
			return emptyBadgesHtml;
		}

		const {
			badgeShowValues,
			badgeLabelValues,
			badgeColorValues,
			badgeBackgroundColorValues
		} = getProductBadgesDataValues(product, currentVariant);

		if (!badgeShowValues.length) {
			return emptyBadgesHtml;
		}

		const badges = badgeShowValues.map((badgeShowValue, index) => {
			const badgeLabel = badgeLabelValues[index];
			const badgeColor = badgeColorValues[index];
			const badgeBackgroundColor = badgeBackgroundColorValues[index];

			const badgeLabelDowncased = badgeLabel.toLowerCase();

			const isSaleBadge = badgeLabelDowncased === metafieldValues.variant.badge.sale;

			if (isSaleBadge && !onSale) {
				return false;
			}

			const badgeStyles = `
				background: ${badgeBackgroundColor};
				color: ${badgeColor};
			`;

			return `
				<div
					class="badge product-card__badge"
					style="${badgeStyles}"
				>
					${badgeLabel}
				</div>
			`;
		}).join('');

		return `<div class="product-card__badges" data-product-badges>
			${badges}
		</div>`;
	}

	function buildProductCardMeta(product) {
		if (!product) {
			return '';
		}

		const productUrl = getProductUrl(product);

		const productTitle = () => {
			return `<a href="${productUrl}" class="product-card__title js-product-url">
				${product.title}
			</a>`;
		};

		const productDescription = () => {
			let description = product?.description

			if (!description) {
				return '';
			}

			description = Utils.stripHtml(description);

			return `<div class="product-card__type">
				${description.substring(0, descriptionTruncateLength)}
			</div>`;
		};

		const productForm = () => {
			let template = boostPFSTemplate.productFormHtml;

			template = template.replace(/{{variantId}}/g, currentVariant.id);
			template = template.replace(/{{minProductPrice}}/g, Utils.formatMoney(currentVariant.price));
			template = template.replace(/{{compareProductPrice}}/g, Utils.formatMoney(currentVariant.compare_at_price));
			template = template.replace(/{{onSale}}/g, onSale ? 'product-card__main-sale' : '');

			template = template.replace(/{{productFormOptions}}/g, buildProductFormOptions(product));
			template = template.replace(/{{productFormWithoutOptions}}/g, buildProductFormWithoutOptions(product));
			template = template.replace(/{{buttonClass}}/g, getProductFormButtonClass());
			template = template.replace(/{{buttonText}}/g, getProductFormButtonText());

			return template;
		};

		return `
			${productTitle()}
			${productDescription()}
			${productForm()}
		`;
	}

    /* Start of custom collection meta */
    function buildProductCardMetaPartOne(product) {
		if (!product) {
			return '';
		}

		const productUrl = getProductUrl(product);

		const productTitle = () => {
			return `<a href="${productUrl}" class="product-card__title js-product-url">
				${product.title}
			</a>`;
		};

		return `
			${productTitle()}
		`;
	}
	
    function buildProductCardMetaPartTwo(product) {
		if (!product) {
			return '';
		}

		const productUrl = getProductUrl(product);

		const productDescription = () => {
			let description = product?.description

			if (!description) {
				return '';
			}

			description = Utils.stripHtml(description);

			return `<div class="product-card__type">
				${description.substring(0, descriptionTruncateLength)}
			</div>`;
		};

		const productForm = () => {
			let template = boostPFSTemplate.productFormHtml;

			template = template.replace(/{{variantId}}/g, currentVariant.id);
			template = template.replace(/{{minProductPrice}}/g, Utils.formatMoney(currentVariant.price));
			template = template.replace(/{{compareProductPrice}}/g, Utils.formatMoney(currentVariant.compare_at_price));
			template = template.replace(/{{onSale}}/g, onSale ? 'product-card__main-sale' : '');

			template = template.replace(/{{productFormOptions}}/g, buildProductFormOptions(product));
			template = template.replace(/{{productFormWithoutOptions}}/g, buildProductFormWithoutOptions(product));
			template = template.replace(/{{buttonClass}}/g, getProductFormButtonClass());
			template = template.replace(/{{buttonText}}/g, getProductFormButtonText());

			return template;
		};

		return `
			${productDescription()}
			${productForm()}
		`;
	}
    /* End of custom collection meta */
  
	function buildProductFormOptions(product) {
		if (hasOnlyDefaultVariant) {
			return '';
		}

		const optionsWithValues = product.options_with_values;

		const options = optionsWithValues.map((option, index) => {
			const downcasedOptionName = option.label.toLowerCase();

			if (sizeOptionLabels.includes(downcasedOptionName)) {
				return buildSizeOption(product, option, index + 1);
			}

			if (colorOptionLabels.includes(downcasedOptionName)) {
				return buildColorOption(product, option, index + 1);
			}
		}).join('');

		if (!options) {
			return '';
		}

		return `<div class="product-card__options">
			${options}
		</div>`;
	}

	function buildProductFormWithoutOptions(product) {
		if (!hasOnlyDefaultVariant) {
			return '';
		}

		let classes = 'product-card__options-button';

		if (!product?.available) {
			classes += ' disabled';
		}

		if (product?.available) {
			classes += ' active';
		}

		return `<div class="product-card__options">
		</div>`;
	}

	function getProductFormButtonClass() {
		if (outOfStock && inventoryPolicy === 'deny') {
			return 'disabled';
		}

		return '';
	}

	function getProductFormButtonText() {
		if (outOfStock && inventoryPolicy === 'deny') {
			return boostPFSThemeConfig.label.button.sold_out;
		} else {
			return boostPFSThemeConfig.label.button.add_to_cart;
		}
	}

	function buildSizeOption(product, option, position) {
		const optionPosition = `option${position}`;
		const currentOptionValueTitle = currentVariant[optionPosition];

		const values = option.values.map((value) => {
			const valueTitle = value.title;

			const matchingVariant = getMatchingVariantByOptionValue(product, valueTitle, optionPosition);
			const matchingVariantAvailable = !!matchingVariant?.available;

			let classes = 'product-card__options-button';

			if (valueTitle === currentOptionValueTitle && currentVariant.available) {
				classes += ' active';
			}

			if (!matchingVariantAvailable) {
				classes += ' disabled';
			}

			classes += ' js-radio-button';

			return `<li class="product-card__options-item">
				<button
					type="button"
					class="${classes}"
					data-product-id="${matchingVariant.id}"
				>
					${valueTitle}
				</button>
			</li>`;
		}).join('');

		return `<ul class="product-card__options-list">
			${values}
		</ul>`;
	}

	function buildColorOption(product, option, position) {
		const optionPosition = `option${position}`;

		const currentOptionValueTitle = currentVariant[optionPosition];

		const values = option.values.map((value) => {
			const valueTitle = value.title;
			const valueTitleHandleized = handleize(valueTitle);

			const matchingVariant = getMatchingVariantByOptionValue(product, valueTitle, optionPosition);
			const matchingVariantAvailable = !!matchingVariant?.available;

			let classes = 'product-card__option-color';

			if (valueTitle === currentOptionValueTitle && currentVariant.available) {
				classes += ' active';
			}

			if (!matchingVariantAvailable) {
				classes += ' disabled';
			}

			classes += ' js-radio-button';

			const swatchColor = valueTitleHandleized;
			const swatchImage = getFileImageUrl(`swatch_${swatchColor}.png`);

			const styles = `
				background-color: ${swatchColor};
				background-image: url(${swatchImage});
			`;

			return `<button
				type="button"
				class="${classes}"
				data-product-id="${matchingVariant.id}"
				style="${styles}"
				value="${valueTitleHandleized}"
			>
			</button>`;
		}).join('');

		return `<div class="product-card__option-colors">
			${values}
		</div>`;
	}

	function getMatchingVariantByOptionValue(product, optionValue, optionPosition) {
		const variants = product?.variants ?? [];

		if (!variants.length) {
			return null;
		}

		return variants.find((variant) => {
			const variantOptionValue = variant[optionPosition];

			if (variantOptionValue === optionValue) {
				return variant;
			}
		});
	}

	function buildProductCardData(product) {
		if (!product) {
			return '';
		}

		const variantsData = {};

		product.variants.forEach((variant) => {
			const getVariantBadges = () => {
				const {
					badgeShowValues,
					badgeLabelValues,
					badgeColorValues,
					badgeBackgroundColorValues
				} = getProductBadgesDataValues(product, variant);

				return {
					badge_visible: badgeShowValues,
					badge_label: badgeLabelValues,
					badge_color: badgeColorValues,
					badge_background: badgeBackgroundColorValues
				};
			};

			const getVariantMedia = () => {
				let featuredMediaSrc = variant.image;

				if (!featuredMediaSrc) {
					featuredMediaSrc = Utils.getFeaturedImage(images).replace('_large.jpg', '.jpg');
				}

				if (!featuredMediaSrc) {
					featuredMediaSrc = images[0]?.src;
				}

				if (!featuredMediaSrc) {
					featuredMediaSrc = boostPFSAppConfig.general.no_image_url;
				}

				let secondaryMediaSrc = null;

				if (!isTouchDevice) {
					secondaryMediaSrc = images[1]?.src;
				}

				return {
					featured_media: {
						src: {
							src: featuredMediaSrc
						}
					},
					secondary_media: secondaryMediaSrc
				};
			};

			variantsData[variant.id] = {
				badges: getVariantBadges(),
				id: variant.id,
				media: getVariantMedia(),
				price: Utils.formatMoney(variant.price),
				url: getProductUrlWithVariant(product, variant)
			};
		});

		return `<script type="application/json" data-product-variant>
			${JSON.stringify(variantsData)}
		</script>`;
	}
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) {
			totalProduct = this.totalProduct;
		}

		// Get page info
		var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
		var totalPage = Math.ceil(totalProduct / Utils.stripHtml(Globals.queryParams.limit));

		if (!currentPage || isNaN(currentPage)) {
			currentPage = 1;
		}

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));

		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));

		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];

		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}

		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}

		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}

		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];

		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}

		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}

		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);

		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}

			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}

		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		let html = '';

		if (!boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			return false;
		}

		const sortingArr = Utils.getSortingList();

		if (!sortingArr) {
			return false;
		}

		let paramSort = Globals.queryParams.sort || '';

		// Build content
		let sortingItemsHtml = '';

		for (let k in sortingArr) {
			let activeClass = '';

			if (paramSort == k) {
				activeClass = ' active';
			}

			sortingItemsHtml += `<li class="collection-sorting__dropdown-item${activeClass}">
									<button type="button" class="boost-pfs-filter-top-sorting-dropdown-option collection-sorting__value" data-sort="${k}">
										${sortingArr[k]}
									</button>
								</li>`;
		}

		html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

		return html;
	};

	ProductSorting.prototype.render = function () {
		const selectors = {
			container: '.boost-pfs-filter-custom-sorting',
			button: '.boost-pfs-filter-top-sorting-dropdown-button'
		};

		const container = jQ(selectors.container);

		if (!container.length) {
			return false;
		}

		const html = this.compileTemplate();

		container.html(html);

		let labelSort = '';

		const paramSort = Globals.queryParams.sort || '';
		const sortingList = Utils.getSortingList();

		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		const button = jQ(selectors.button);
		button.text(labelSort);
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		const selectors = {
			dropdownTrigger: '.boost-pfs-filter-top-sorting-dropdown-trigger',
			dropdownTriggerButton: '.boost-pfs-filter-top-sorting-dropdown-button',
			option: '.boost-pfs-filter-top-sorting-dropdown-option'
		};

		const dropdownTrigger = jQ(selectors.dropdownTrigger);
		const dropdownTriggerButton = jQ(selectors.dropdownTriggerButton);
		const option = jQ(selectors.option);

		option.click(function (e) {
			e.preventDefault();

			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		dropdownTrigger.click(function () {
			dropdownTrigger.toggleClass('active');
		});

		jQ(document).on("click", function (e) {
			if (jQ(e.target).is(dropdownTrigger) === false && jQ(e.target).is(dropdownTriggerButton) === false) {
				jQ(dropdownTrigger).removeClass("active");
			}
		});
	};
	/************************** END BUILD TOOLBAR **************************/

	/************************** BUILD ADDITIONAL ELEMENTS **************************/
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		const selectors = {
			products: '[data-collection-products]'
		};

		initProductCards();
		initSwymIntegration();

		function initProductCards() {
			document.dispatchEvent(new CustomEvent("product-cards:init"));
		}

		function initSwymIntegration() {
			/** Start Swym integration **/
			window.SwymCallbacks = window.SwymCallbacks || [];

			window.SwymCallbacks.push(function(swat) {
				const products = [];

				data.forEach(function(product) {
					const image_src = Utils.getFeaturedImage(product.images_info);
					const productCopy = product;

					productCopy.featured_image = image_src;
					productCopy.price = product.price_min;
					productCopy.compare_at_price = product.compare_at_price_min;

					products.push(productCopy);
				});

				swat.mapShopifyProducts(products);
				swat.initializeActionButtons(selectors.products);
			});
			/** End Swym integration **/
		}
	}

	Filter.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;

		const selectors = {
			products: '[data-collection-products]'
		};

		const modifiers = {
			loading: 'boost-loading'
		};

		removeLoading();

		function removeLoading() {
			jQ(selectors.products).removeClass(modifiers.loading);
		}
	};

	FilterResult.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		const selectors = {
			grid: '[data-collection-grid]'
		};

		const modifiers = {
			grid: {
				loading: 'boost-loading'
			}
		};

		removeLoadingState();

		function removeLoadingState() {
			jQ(selectors.grid).removeClass(modifiers.grid.loading);
		}
	};
	/************************** END BUILD ADDITIONAL ELEMENTS **************************/

	/************************** START HELPERS **************************/
	function getFileImageUrl(filename) {
		return boostPFSThemeConfig.helpers.file_image_url.replace("%filename%", filename);
	}

	function handleize(value) {
		return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
	}
	/************************** END HELPERS **************************/

    /* Start-Boost- */
    Utils.getFilePath = function(fileName, extension, version) {
    	var extension = typeof extension !== 'undefined' ? extension : 'png';
    	var version = typeof version !== 'undefined' ? version : '';
        Globals.fileUrl = Globals.fileUrl.replace(/__/g, '//').replace(/_/g, '/');
    	var filePath = Globals.fileUrl.split('?')[0];
    	filePath += fileName + '.' + extension + (version ? ('?v=' + version) : '');
    	return filePath;
    }
})();
